import type { IToast } from '../../toast/interface';
import { injectToast } from '../../toast/interface';
import { TOAST_MESSAGE } from './constants';

/* Cast as optional as we may be executing before toast has been injected */
const _toaster = () => injectToast() as IToast | undefined;

const show = () => !isShowing() && _toaster()?.show(TOAST_MESSAGE);
const hide = () => _toaster()?.hide(TOAST_MESSAGE);
const isShowing = () => _toaster()?.isShowing(TOAST_MESSAGE) ?? false;

export default Object.freeze({
    show,
    hide,
    isShowing,
});
